var app = app || {};
app.cw = app.cw || {};
app.cw.session = app.cw.session || {};

(function () {
    $(function () {
        if (!app.cw.session.inIframe()) { // only run if page is not in iframe
            // don't run session expiration scripts on certain pages
            var pathname = window.location.pathname;

            if (pathname === '/Identity/Account/Login')
                return;
            if (pathname === '/Identity/Account/Logout')
                return;
            if (pathname === '/Identity/Account/ForgotPasswordConfirmation')
                return;
            if (pathname === '/Identity/Account/ForgotPassword')
                return;
            //if (location.hostname === 'localhost')
            //	return;

            // Don't run session expiration scripts if modal doesn't exist
            if ($('#warningMessage').length === 0) {
                return;
            }

            // Initialize session expiration warning
            app.cw.session.sessExpirationWarningInit();
        }

    });

    app.cw.session = {
        // Check if page is in iframe
        inIframe: function () {
            try {
                return window.self !== window.top;
            }
            catch (e) {
                return true;
            }
        },

        // ----------------------------- Session expiration warning ----------------------------- //
        sessExpirationWarningInit: function () {
            // Share this session access with all other open tabs/windows for the same session
            sessSetLastActivity();

            // Timeout settings
            var sess_pollInterval = 10000;									// How frequently to check for session expiration in milliseconds
            var sess_warningMinutesBeforeExpiration = 5;		// How many minutes before session expiration the warning appears
            var sess_bufferSeconds = 90;										// How many seconds before the anticipated server session expiration the UI assumes server exiration

            // Do not change these
            var sess_expirationMinutes = $.trim($('#ix_expiration').text()); //How many minutes the session is valid for

            //// Settings for debugging
            //sess_expirationMinutes = 2;
            //sess_warningMinutesBeforeExpiration = 1;
            //sess_bufferSeconds = 0;

            redirected = false;

            // Don't run session expiration script if sess_expirationMinutes is not set (iframes)
            if (sess_expirationMinutes === "") {
                return;
            }

            var sess_expirationSeconds = sess_expirationMinutes * 60 - sess_bufferSeconds;
            var sess_warningSeconds = sess_expirationSeconds - sess_warningMinutesBeforeExpiration * 60;
            var sess_keepaliveSeconds = 60;

            var sess_intervalID;
            var sess_countDownTimerId;
            var sess_WarningVisible = false;

            sessSetInterval();
            //console.log('init');
            // any clicks or keydown on the page will reset the session expiration
            $('body').on('click', function (e) {
                if (!$(e.target).hasClass('ix_warningmessage_btn')) {
                    sessionKeepAlive(false);
                }
            });

            $(document).on('keypress.session', function (ed, e) {
                // console.log('keypress.session event');
                sessionKeepAlive(false);
            });

            // Gets the last activity from any open tabs/windows for the session
            function sessGetLastActivity() {
                var lastAccess = Cookies.get("CwLastAccess");

                return moment(lastAccess);
            }

            // Share this session access with all other open tabs/windows for the same session
            function sessSetLastActivity() {
                Cookies.set("CwLastAccess", moment().format(),
                    {
                        path: '/',
                        secure: location.protocol === 'https:',
                        sameSite: 'Lax'
                    });
                // console.log("set cookie last access " + Cookies.get("CwLastAccess"));
            }

            // Share this session access with all other open tabs/windows for the same session
            function sessSetLastActivityExpired() {
                Cookies.set("CwLastAccess", moment("2000-01-01").format(),
                    {
                        path: '/',
                        secure: location.protocol === 'https:',
                        sameSite: 'Lax'
                    });
                // console.log("set cookie expired " + Cookies.get("CwLastAccess"));
            }

            // Set up polling function, run every sess_pollInterval
            function sessSetInterval() {
                sess_intervalID = setInterval(sessInterval, sess_pollInterval);
            }

            function sessLogOut() {
                console.log("log off clicked!");
                sessSetLastActivityExpired();
                //window.location.href = '/Identity/Account/Logout';
            }

            function sessTimedOut() {
                if (redirected) {
                    // console.log("exipred - already redirected");
                    return;
                }
                clearInterval(sess_intervalID);
                clearInterval(sess_countDownTimerId);

                const token = $('input[name="__RequestVerificationToken"]').val();

                document.body.innerHTML = "<b>Session has expired.</b>";
                redirected = true;
                //window.location.href = '/Identity/Account/Logout?Reason=TimedOut&timestamp=' + moment().valueOf();

                $.ajax({
                    type: 'POST',
                    url: '/Identity/Account/Logout',
                    headers: { 'RequestVerificationToken': token },
                    cache: false,
                    data: { reason: 'TimedOut' },
                    dataType: 'json'
                }).done(function (obj) {
                    window.location.href = '/Identity/Account' + obj.RedirectUrl + '?Reason=TimedOut';
                }).fail(function (err) {
                    //console.log(err);
                });
            }

            function sessionKeepAlive(force) {
                var lastAccess = sessGetLastActivity();
                var diffSeconds = moment().diff(lastAccess, "seconds");
                // console.log("------------------------------");
                // console.log("keepalive diff seconds: " + diffSeconds);

                // On UI activity: Update the shared cookie and ping the server every minute
                // As we do not know about the last AJAX call sent to the server we will send
                // a ping on UI activity every sess_keepaliveSeconds
                if (force || diffSeconds >= sess_keepaliveSeconds) {
                    sessSetLastActivity();
                    serverKeepAlive();
                }
            }

            function serverKeepAlive() {
                // console.log("server keepalive sent");
                $.ajax({
                    type: "POST",
                    url: "/Home/KeepAlive",
                    cache: false,
                    dataType: "json"
                }).done(function (msg) {
                    // console.log('keep alive OK: ' + msg);
                }).fail(function (err) {
                    // console.log('keep alive failed: ');
                    // console.log(err);
                });
            }

            function sessIsWarning() {
                var lastAccess = sessGetLastActivity();
                var warningOn = moment(lastAccess);
                warningOn.add(sess_warningSeconds, "seconds");
                var secondsUntilWarning = warningOn.diff(moment(), "seconds");

                var expireOn = moment(lastAccess);
                expireOn.add(sess_expirationSeconds, "seconds");
                var secondsUntilExpiration = expireOn.diff(moment(), "seconds");

                // console.log("--------------------------------");
                // console.log("now: " + moment().format("hh:mm:ss"));
                // console.log("last access: " + moment(lastAccess).format("hh:mm:ss") + ", " + moment().diff(lastAccess, "seconds") + " seconds ago");
                // console.log("warningOn: " + moment(warningOn).format("hh:mm:ss") + "  in " + secondsUntilWarning);
                // console.log("expirationOn: " + moment(expireOn).format("hh:mm:ss") + "  in " + secondsUntilExpiration);

                return (secondsUntilWarning <= 0);
            }

            function sessSecondsUntilExiration() {
                var lastAccess = sessGetLastActivity();
                var expiresOn = moment(lastAccess);
                expiresOn.add(sess_expirationSeconds, "seconds");
                var secondsUntilTimeout = expiresOn.diff(moment(), "seconds");
                // console.log("seconds until timeout: " + secondsUntilTimeout);

                return secondsUntilTimeout;
            }

            // Show warning message
            function sessShowWarningMessage() {
                $('#warningMessage').modal({
                    show: true,
                    backdrop: true,
                    keyboard: false
                });
                sess_WarningVisible = true;
                // console.log("sessShowWarningMessage");
            }

            function OneSecondContdown() {
                sessShowWarningMessage();

                var secondsLeft = sessSecondsUntilExiration();

                // Update countdown
                $("#countTime").html(moment.duration(Math.max(secondsLeft, 1), "seconds").humanize(true));
                var lastAccess = sessGetLastActivity();
                $("#lastAccess").html(moment(lastAccess).format("hh:mm:ss") + ", " + moment().diff(lastAccess, "seconds") + " seconds ago");

                // console.log("Seconds left: " + secondsLeft);
                if (!sessIsWarning())
                    sessHideWarningMessage();
                if (secondsLeft <= 0)
                    sessTimedOut();
            }

            // Hide the warning message
            function sessHideWarningMessage() {
                // Stop countdown timer
                clearInterval(sess_countDownTimerId);
                // console.log("Stop countdown");

                $('#warningMessage').modal('hide');
                sess_WarningVisible = false;
            }

            // Show warning if within warn interval
            function sessInterval() {
                if (sessIsWarning()) {
                    // Don't do anything if the warning is already active
                    if (sess_WarningVisible)
                        return;

                    // Make warning modal visible
                    sessShowWarningMessage();

                    // Start Countdown
                    sess_countDownTimerId = setInterval(OneSecondContdown, 1000); //1000ms. = 1sec.

                    // Handle log off button
                    $('#btnLogoff').click(function () {
                        sessLogOut();
                        $('#cw_ajax_log_off_form').trigger('submit');
                    });

                    // Handle resume session button
                    $('#btnResumeSession').click(function () {
                        sessHideWarningMessage();
                        sessionKeepAlive(true);
                    });
                }
            }
        }

    };
})();
